import { render, staticRenderFns } from "./memos.vue?vue&type=template&id=00d7254c"
import script from "./memos.vue?vue&type=script&lang=js"
export * from "./memos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports